import { DotCMSGraphQLParams } from '@dotcms/types';

export const blogQuery = `
    search(query: "+contenttype:Blog +live:true", limit: 3) {
        title
        identifier
        ... on Blog {
            inode
            image {
                fileName
                fileAsset {
                    versionPath
                }
            }
            urlMap
            modDate
            urlTitle
            teaser
            author {
                firstName
                lastName
                inode
            }
        }
    }
`;

const page = `
urlContentMap{
              ... on Blog {
            inode
            position
            imageBlog:image {
              path
              idPath
              width
              height
            }
            urlMap
            modDate
            urlTitle
            teaser
             author {
                firstName
                lastName
                inode
                profilePhoto{title path idPath width height}
            }
              blogComment{
              body
              postDate
              emailResponse
              contentType
              creationDate
              reply{
              postDate
              body
                 commentAuthor{
                firstName
                lastName
                inode
                profilePhoto{title path idPath width height}
              }
              }
              commentAuthor{
                firstName
                lastName
                inode
                profilePhoto{title path idPath width height}
              }

              }
        }
}
containers {
  containerContentlets {
    contentlets {
            ... on Blog {
            inode
            position
            imageBlog:image {
              path
              idPath
              width
              height
            }
            urlMap
            modDate
            urlTitle
            teaser
             author {
                firstName
                lastName
                inode
                profilePhoto{title path idPath width height}
            }
            postingDate
            publishDate
        }
      ... on FaqWidget {
          faq {
            contentType
            question
            answer
          }
        }
        ... on Banner {
        title
        bannerTitle
        animations
        caption
        link
        buttonText
        layout
        backgroundColor
        imagelg { title path idPath width height}
        imagemd { title path idPath width height}
        imagesm { title path idPath width height}
        maxWidth
        textColor
        buttonColor
        expire
        publish
        dotStyleProperties
      }
        ... on BannerVideo {
        title
        caption
        bannerVideoTitle :bannerTitle
        link
        animations
        buttonText
        fileAsset { title path idPath width height}
        disableAutoplay
        maxWidth
        buttonColor
        sortOrder
        textColor
        cssClass
        publish
        expire
        dotStyleProperties
        }
        ... on Image {
        title
        animations
        fileAsset { title path idPath width height}
        description
        publishDate
        expireDate
        sortOrder
        link
        dotStyleProperties
        }
        ... on DefaultVideo{
        fileAsset { title path idPath width height}
        autoPlayVideo : autoPlay
        mute
        heightlg
        heightmd
        heightsm
        cssClass
        sortOrder
        publish
        expire
        }
              ... on webPageContent {
        identifier
        title
        body
        modDate
        inode
        working
        live
        contentType
        creationDate
        baseType
        archived
      }
      ... on ProductCarousel {
        title
        productCarouselTitle
        noOfItems
        productCards
        cssClass
        show
        slideItems
        showIndicator
        listItemCssClass
        loop
        speed
        autoPlay
        layout
        publish
        expire
        dotStyleProperties
        }
              ... on Category {
        title
        categoryTitle
        allCategories
        cssClass
        listItemCssClass
        slideItems
        showIndicator
        loop
        speed
        autoPlay
        layout
        publish
        expire
        dotStyleProperties
        }
                      ... on CategoryCard {
        allCategories
        publish
        expire
        }
                ... on VideoVimeo{
        autoPlayVideo: autoPlay
        url
        mute
        heightlg
        heightmd
        heightsm
        cssClass

        }
                        ... on Video{
        title
        autoPlayVideo: autoPlay
        url
        mute
        heightlg
        heightmd
        heightsm
        cssClass
        publish
        expire
        sortOrder
        maxWidth
        }
              ... on ProductsTooltip {
        search
        tooltipDetails
        maxWidth
        productSkus
        image { title path idPath width height}
        imagemd { title path idPath width height}
        imagesm { title path idPath width height}
        }
        ... on GlobalCarousel{
          showIndicator
          loop
          maxWidth
          verticalCenter
          enableSpace
          animatePagination
          animateNavigation
          speed
          autoPlay
          navLayout
          noOfItems
          slideItems
              productsTooltip{
                contentType
                search
                tooltipDetails
                maxWidth
                image { title path idPath width height}
                imagemd { title path idPath width height}
                imagesm { title path idPath width height}
                sortOrder
              }
              images{
                contentType
                animations
                title
                fileAsset { title path idPath width height}
                description
                sortOrder
                publishDate
                expireDate
              }
              banners{
                contentType
                title
                caption
                animations
                link
                buttonText
                layout
                backgroundColor
                imagelg { title path idPath width height}
                imagemd { title path idPath width height}
                imagesm { title path idPath width height}
                maxWidth
                textColor
                buttonColor
                sortOrder
                expire
                publish
             }
              videos{
                contentType
                title
                autoPlayVideo: autoPlay
                url
                mute
                heightlg
                heightmd
                heightsm
                cssClass
                publish
                expire
                sortOrder
                maxWidth
              }
              categoryCard{
                  contentType
                  allCategories
                  sortOrder
                  publish
                  expire
              }

        }
        ... on Carousel {
        startCycling
        slideItems
        maxWidth
        showIndicator
        slideInterval
        banners{
        contentType
        bannerTitle
        title
        caption
        link
        buttonText
        layout
        animations
        backgroundColor
        imagelg { title path idPath width height}
        imagemd { title path idPath width height}
        imagesm { title path idPath width height}
        maxWidth
        textColor
        buttonColor
        sortOrder
        expire
        publish
        }
        images{
                contentType
                animations
                title
                fileAsset { title path idPath width height}
                description
                sortOrder
                publishDate
                expireDate
              }
        videos{
        contentType
        title
        autoPlay
        url
        mute
        heightlg
        heightmd
        heightsm
        cssClass
        publish
        expire
        sortOrder
        maxWidth
        }
        productsTooltip{
        contentType
        search
        tooltipDetails
        sortOrder
        maxWidth
        image { title path idPath width height}
        imagemd { title path idPath width height}
        imagesm { title path idPath width height}
        sortOrder
        }
     }
    }
  }
}
`;

// const page = `
// fragment ClientPage on DotContentlet {
//   publishDate
//   inode
//   identifier
//   archived
//   urlMap
//   locked
//   contentType
//   creationDate
//   modDate
//   title
//   baseType
//   working
//   live
//   publishUser {
//     firstName
//     lastName
//   }
//   owner {
//     lastName
//   }
//   conLanguage {
//     language
//     languageCode
//   }
//   modUser {
//     firstName
//     lastName
//   }
//   faq {
//     question
//     answer
//   }
// }
// `;

// const pageFragment = `
// fragment ClientPage on DotPage {
//   publishDate
//   inode
//   identifier
//   archived
//   urlMap
//   locked
//   contentType
//   creationDate
//   modDate
//   title
//   baseType
//   working
//   live
//   publishUser {
//     firstName
//     lastName
//   }
//   owner {
//     lastName
//   }
//   conLanguage {
//     language
//     languageCode
//   }
//   modUser {
//     firstName
//     lastName
//   }
//   faq {
//     question
//     answer
//   }
// }
// `;

export const footerQuery = (identifier: string) => `
    search(
      query: "+contentType:webPageContent +identifier:${identifier} +live:true",
      limit: 1
    ) {
      ... on webPageContent {
        identifier
        title
        body
        modDate
        inode
        working
        live
        contentType
        creationDate
        baseType
        archived
      }
    }
`;
export const destinationQuery = `
    search(query: "+contenttype:Destination +live:true", limit: 3) {
        title
        identifier
        ... on Destination {
                inode
                image {
                fileName
                fileAsset {
                    versionPath
                }
                }
                urlMap
                modDate
                url
        }
    }
`;

/**
 * Generate nested children structure for GraphQL query
 */
export function buildChildren(depth: number): string {
  if (depth <= 0) {
    return '';
  }
  return `
    children {
      ...NavProps
      ${buildChildren(depth - 1)}
    }
  `;
}

/**
 * Generate the full navigation query (without fragment definition)
 * because fragments are injected separately via BASE_EXTRA_QUERIES.fragments
 */
export function createNavigationQuery(depth: number): string {
  return `
    DotNavigation(uri: "/", depth: ${depth}) {
      ...NavProps
      ${buildChildren(depth)}
    }
  `;
}

export function createPageQuery(url = '/index'): string {
  return `
    page(url: "${url}") {
      ...PageProps
    }
  `;
}

export const fragmentPage = `
fragment PageProps on DotPage {
  transparentHeader: _map(key: "transparentHeader")
  schema: _map(key: "schema")
  seoTitle: _map(key: "seoTitle")
  seoTitleCount: _map(key: "seoTitleCount")
  seodescription: _map(key: "seodescription")
  seoDescriptionCount: _map(key: "seoDescriptionCount")
  seoKeywords: _map(key: "seoKeywords")
  pagemetadata: _map(key: "pagemetadata")
  pageTitleCount: _map(key: "pageTitleCount")
  metaDescription: _map(key: "metaDescription")
  metaDescriptionCount: _map(key: "metaDescriptionCount")
  metaKeywords: _map(key: "metaKeywords")
  canonicalUrl: _map(key: "canonicalUrl")
  searchEngines: _map(key: "searchEngines")
  searchEngineIndex: _map(key: "searchEngineIndex")
  sitemap1: _map(key: "sitemap1")
  sitemap: _map(key: "sitemap")
  sitemapImportance: _map(key: "sitemapImportance")
  openGraph: _map(key: "openGraph")
  ogPreview: _map(key: "ogPreview")
  ogType: _map(key: "ogType")
  ogTitle: _map(key: "ogTitle")
  ogDescription: _map(key: "ogDescription")
  ogDescriptionCount: _map(key: "ogDescriptionCount")
  ogImage: _map(key: "ogImage")
}`;

export const navigationQuery = `
DotNavigation(uri: "/", depth: 5) {
  ...NavProps
  children {
    ...NavProps
  }
}
`;

export const fragmentNav = `
fragment NavProps on DotNavigation {
    code
    folder
    hash
    host
    href
    languageId
    order
    target
    title
    type
}
`;

export const BASE_EXTRA_QUERIES: DotCMSGraphQLParams = {
  page,
  content: {
    //     logoImage: `FileAssetCollection(query: "+title:logo.png") {
    //   fileAsset {
    //     versionPath
    //   }
    // }`,
    //     blogs: blogQuery,
    //     destinations: destinationQuery,
    // navigation: createNavigationQuery(5),
  },
  fragments: [],
};
